// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3Pzat","inputWrap":"CustomTip_inputWrap__35L33"};